export default {
  data () {
    return {
    }
  },
  methods: {
    downloadExcel (file) {
      console.log('DOWNLOADING FILE <--', file)
      let nombre = file.name
      let binario = atob(file.file_base64)
      let array = []
      for (let i = 0; i < binario.length; i++) {
        array.push(binario.charCodeAt(i))
      }
      let blob = new Blob([new Uint8Array(array)], { type: 'application/xlsx' })
      // let blob = URL.createObjectURL(new Blob([new Uint8Array(array)], { type: 'application/xslx' }))
      console.log('BLOB: ', blob)
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveOrOpenBlob(blob, nombre)
      } else {
        let a = window.document.createElement('a')
        a.href = window.URL.createObjectURL(blob, { type: 'application/xlsx' })
        a.download = nombre
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    }
  }
}
